<template>
  <b-row>
    <b-col v-for="(field, index) in formSpecs.fields" :key="index" v-bind="field.layout">
      <b-form-group>
        <label v-if="field.outsideLabel" class="label-size-lg" :class="field.class">{{ field.label }} </label>
        <component
          :ref="field.model"
          :is="field.component"
          v-model="form[field.model]"
          :label="field.label"
          v-bind="field.customAttributes"
          :class="field.class"
          :options="field.options"
          :input-type="field.inputType"
          :submitted="submitted"
          :invalid="$v.form[field.model].$error"
          :required="'required' in $v.form[field.model] && !$v.form[field.model].required"
          :email="'email' in $v.form[field.model] && !$v.form[field.model].email"
          :numeric="'numeric' in $v.form[field.model] && !$v.form[field.model].numeric"
          :url="'url' in $v.form[field.model] && !$v.form[field.model].url"
          :min-length="'minLength' in $v.form[field.model] && !$v.form[field.model].minLength"
          :max-length="'maxLength' in $v.form[field.model] && !$v.form[field.model].maxLength"
          :decimal="'decimal' in $v.form[field.model] && !$v.form[field.model].decimal"
          :min-value="'minValue' in $v.form[field.model] && !$v.form[field.model].minValue"
          :max-value="'maxValue' in $v.form[field.model] && !$v.form[field.model].maxValue"
        >
          <div v-if="field.insideLabel">
            {{ field.label }}
          </div>
          <!-- Add label for checkbox -->
        </component>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
/*
  Auto-form component
    - Generate form from formSpecs
      This component is used to generate form from formSpecs object.
      formSpecs object is defined in the parent component.
      formSpecs object contains the following properties:
        - fields: array of fields
          Each field contains the following properties:
            - component: string
              The component to use for the field
            - model: string
              The model of the field
            - label: string
              The label of the field
            - inputType: string
              The input type of the field
            - validation: object
              The validation of the field
            - customAttributes: object
              The custom attributes of the field
            - layout: object
              The layout of the field
        - ressourceClass: object from sdk
          The ressource class of the form
        - successCreateMessage: string
          The success message to display when the form is submitted (creation) with success
        - successEditMessage: string
          The success message to display when the form is submitted (edition) with success
*/

import { FunctionHelpers } from '@/node-sdk'

export default {
  name: 'auto-form',
  data() {
    return {
      form: this.value,
      submitted: false,
      modify: false,
    }
  },
  props: {
    formSpecs: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
    },
  },
  validations() {
    let validation = {
      form: {},
    }
    this.formSpecs.fields.forEach((field) => {
      if (field.validation) {
        validation.form[field.model] = field.validation
      }
    })
    return validation
  },
  watch: {
    form() {
      this.$emit('input', this.form)
    },
    value() {
      this.form = this.value
    },
  },
  methods: {
    initForm(modify, instance) {
      this.submitted = false
      this.form = instance
      this.modify = modify
      if (!modify) {
        this.form = this.formSpecs.ressourceClass.get_form()
      } else {
        this.form = instance
      }
    },
    validate() {
      this.$v.$touch()
      return this.$v.$invalid
    },
    async create() {
      this.formSpecs.fields.forEach(async (field) => {
        if (field.component === 'h-f-model-multi-taggable') {
          await this.$ref[field.model].createNewOption()
        }
      })
      this.$v.$touch()
      if (this.$v.$invalid) {
        FunctionHelpers.formErrorModal()
      } else {
        // Add additionnals params to patch
        let resp = await this.formSpecs.ressourceClass.create(this.form)
        this.$toast.open(FunctionHelpers.getToastSuccessOptions(this.formSpecs.successCreateMessage))
        this.$emit('create', resp)
        this.submitted = false
      }
    },
    async edit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        FunctionHelpers.formErrorModal()
      } else {
        // Add additionnals params to patch
        let resp = await this.formSpecs.ressourceClass.patch(this.form.id, { data: { ...this.form } })
        this.$toast.open(FunctionHelpers.getToastSuccessOptions(this.formSpecs.successEditMessage))
        this.$emit('edit', resp)
        this.submitted = false
      }
    },
    submit() {
      this.submitted = true
      if (!this.modify) {
        this.create()
      } else {
        this.edit()
      }
    },
  },
}
</script>

<style scoped></style>
